import apollo from '@/graphql'

import CompanyTypesQuery from '@/graphql/company/CompanyTypesQuery.gql'
import RolesQuery from '@/graphql/user/RolesQuery.gql'
import UsersQuery from '@/graphql/user/UsersQuery.gql'

// initial state
const state = {
  companyTypes: [],
  roles: [],
  users: [],
  userTotal: 0,
  isUserListLoading: false,
  searchTerm: '',
}

// getters
const getters = {
  companyTypes: state => state.companyTypes,
  isUserListLoading: state => state.isUserListLoading,
  roles: state => state.roles,
  users: state => state.users,
  userTotal: state => state.userTotal,
}

// mutations
const mutations = {
  initializeStore(state) {
    state.users = []
  },
  setCompanyTypes(state, companyTypes) {
    state.companyTypes = companyTypes
  },

  setRoles(state, roles) {
    state.roles = roles
  },

  setUsers(state, users) {
    state.users = users
  },

  setUserTotal(state, userTotal) {
    state.userTotal = userTotal
  },

  setUserListLoading(state, value) {
    state.isUserListLoading = value
  },

  setSearchTerm(state, value) {
    state.searchTerm = value
  },
}

// actions
const actions = {
  init({ commit }) {
    commit('initializeStore')
  },
  loadCompanyTypes({ commit }) {
    apollo.defaultClient
      .watchQuery({
        query: CompanyTypesQuery,
      })
      .subscribe(({ data: { companyTypes } }) => {
        commit('setCompanyTypes', companyTypes)
      })
  },

  loadRoles({ commit }) {
    apollo.defaultClient
      .watchQuery({
        query: RolesQuery,
      })
      .subscribe(({ data: { roles } }) => {
        commit('setRoles', roles)
      })
  },

  loadUsers({ commit }, payload) {
    const variables = {
      offset: 0,
      limit: 10,
      sortBy: '',
      sortOrder: '',
      search: '',
      isDeleted: false,
      companiesIds: [],
      ...payload,
    }
    commit('setUserListLoading', true)
    apollo.defaultClient
      .watchQuery({
        query: UsersQuery,
        variables,
      })
      .subscribe(({ data: { users } }) => {
        commit('setUsers', users.list)
        commit('setUserTotal', users.filter.total)
        commit('setUserListLoading', false)
      }, (error) => {
        // eslint-disable-next-line no-console
        console.log(error.message)
        commit('setUserListLoading', false)
      })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/user/UserList.js